import CloseIcon from "mdi-react/CloseIcon";
import React from "react";
import {
  Modal,
  ModalBody,
  ButtonToolbar,
  ModalFooter,
  Row,
  Col,
  Button,
} from "reactstrap";

const ApprovalConfirmPopup = ({
  modalOpen,
  modalToggle,
  setName,
  onApprovalFlowSubmit,
}) => {
  return (
    <>
      <Modal
        isOpen={modalOpen}
        className={`modal-small modal-md p-0`}
        toggle={modalToggle}
      >
        <div className="close cursor-pointer">
          <CloseIcon
            onClick={() => {
              setName("ApprovalFlow");
              modalToggle();
            }}
            size={30}
          />
        </div>
        <Row>
          <p style={{ fontSize: "16px" }}>
            {" "}
            Are you sure you want to confirm these approval changes?
          </p>
        </Row>
        {/* <Row>
          <Col md="12" lg="12" xl="12">
            <ModalBody>
              <p style={{ fontSize: "16px", textAlign: "justify" }}>
                {" "}
                Are you sure you want to confirm these approval changes?
              </p>
            </ModalBody>
          </Col>
        </Row> */}
        <ModalFooter className="w-100 d-flex justify-content-center">
          <ButtonToolbar>
            <Button
              color="ffff"
              type="submit"
              onClick={onApprovalFlowSubmit}
              className="btn btn-secondary text-center d-flex justify-content-center align-items-center"
               style={{ fontSize: "0.85rem" }}
            >
            Save Changes
            </Button>

            {/* <Button
              color="ffff"
              type="button"
              className="btn btn-primary"
              onClick={() => {
                setName("ApprovalFlowProgramHierarchy");
                modalToggle();
              }}
              size="md"
            >
              Yes, Save to Hierarchy
            </Button> */}
          </ButtonToolbar>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ApprovalConfirmPopup;
